module.exports = __webpack_public_path__ + "img/start_academy_hh.c7b70411.png";